import Footer from "../components/dev/Footer";
import noise from "../contents/dev/noise.png";
import React, {useCallback, useRef, useState} from "react";
import {Link} from "react-router-dom";
import gradientW from "../contents/dev/gradient-white.png";
import gradientY from "../contents/dev/gradient-yellow.png";
import gt from "../contents/dev/GoldenTides.png";
import {Canvas} from "@react-three/fiber";
import * as THREE from "three";
import {FBOParticles} from "../shaders/FBOParticles";

export default function MainHome() {
    const mouseRef = useRef({x: 0.5, y: -0.5});
    const [bgVersion, setBgVersion] = useState("");
    const switchToMainVersion = useCallback(() => {
        setBgVersion("");
    }, []);
    const switchToDevVersion = useCallback(() => {
        setBgVersion("dev");
    }, []);
    const switchToWebVersion = useCallback(() => {
        setBgVersion("web");
    }, []);

    console.log(bgVersion);

    return (
        <div className={"flex flex-grow flex-col h-full " + (bgVersion === "" ? "bg-black" : "")}>
            {bgVersion === "web" ? <Canvas
                gl={{antialias: true, toneMapping: THREE.NoToneMapping}}
                linear
                camera={{position: [6, 0, 0]}}
                style={{position: "fixed", top: 0, left: 0, zIndex: -1, background: 'black'}}>
                <FBOParticles mouseRef={mouseRef}/>
                <ambientLight intensity={0.5}/>
            </Canvas> : null}
            {bgVersion === "dev" ?
                <div className="bg-black" style={{
                    width: "100%",
                    height: "100%",
                    position: "fixed",
                    zIndex: -1,
                }}>
                    <div style={{
                        width: "100%",
                        height: "100%",
                        opacity: 0.3,
                        backgroundImage: "url(" + gt + ")",
                        backgroundSize: "cover", // contain
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                    }}></div>
                </div> : null}

            <div className="content flex-grow content-padding pt-24">
                <div>
                    <div className="text-white text-center space-y-10 w-full px-12 2xl:px-0 2xl:pr-12">
                        <div className="block text-4xl font-medium">
                            <div>
                                3dot <span
                                className="text-yellow-400"> Studio is a team of 3D and game-dev enthusiasts </span>
                            </div>
                            <div>
                                with 10 years of experience building games.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-center text-4xl text-white mt-24">
                    <span className="text-yellow-400">Our</span> Services
                </div>
                <div className="flex md:w-full flex-wrap justify-center gap-x-12 mt-12 mx-4 md:mx-0 mb-12">
                    <div className="group"
                         onMouseEnter={switchToDevVersion} onMouseLeave={switchToMainVersion}>
                        <div className="card-info relative flex pt-8 sm:pt-0 my-12">
                            <div className="card bg-gray-1 text-white p-6" style={{backgroundImage: `url(${noise})`}}>
                                <div className="py-4 text-xl font-medium border-gray-2 border-b-2">
                                    Game dev:
                                </div>
                                <div className="py-4 font-light">
                                    3DotStudio is a team of game-dev enthusiasts with 10 years of experience building
                                    games.
                                    We partner with a fantastic team of artists to provide full-circle services.
                                </div>
                            </div>
                            <div className="card-part bg-gray-1 -ml-4" style={{backgroundImage: `url(${noise})`}}/>
                            <div
                                className="absolute left-32 bottom-52 sm:bottom-48 p-2 flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400">
                                <svg width="58" height="50" viewBox="0 0 71 46" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M63.9469 12.641C58.7869 1.47097 53.9269 1.70098 49.6169 2.16098C45.2969 2.62098 38.5969 5.17097 35.2069 5.17097C31.8169 5.17097 25.1169 2.63098 20.7969 2.16098C16.4869 1.70098 11.6269 1.47097 6.46691 12.641C1.30691 23.811 0.916915 38.141 3.76691 42.461C6.61691 46.771 14.0969 41.771 19.5669 37.301C25.0369 32.831 29.8169 31.211 35.2069 31.211C40.5969 31.211 45.3769 32.831 50.8469 37.301C56.3169 41.771 63.7869 46.781 66.6469 42.461C69.4969 38.141 69.1069 23.811 63.9469 12.641Z"
                                        stroke="#FACC15" strokeWidth="3.5" strokeMiterlimit="10"
                                        strokeLinejoin="round"/>
                                    <path
                                        d="M24.3856 15.5909H22.7656C22.2756 15.5909 21.8656 15.1909 21.8656 14.6909V13.0709C21.8656 11.4909 20.5856 10.2109 19.0056 10.2109C17.4256 10.2109 16.1456 11.4909 16.1456 13.0709V14.6909C16.1456 15.1809 15.7456 15.5909 15.2456 15.5909H13.6256C12.0456 15.5909 10.7656 16.8709 10.7656 18.4509C10.7656 20.0309 12.0456 21.3109 13.6256 21.3109H15.2456C15.7356 21.3109 16.1456 21.7109 16.1456 22.2109V23.8309C16.1456 25.4109 17.4256 26.6909 19.0056 26.6909C20.5856 26.6909 21.8656 25.4109 21.8656 23.8309V22.2109C21.8656 21.7209 22.2656 21.3109 22.7656 21.3109H24.3856C25.9656 21.3109 27.2456 20.0309 27.2456 18.4509C27.2456 16.8709 25.9656 15.5909 24.3856 15.5909Z"
                                        stroke="#FACC15" strokeWidth="3.5" strokeMiterlimit="10"
                                        strokeLinejoin="round"/>
                                    <path
                                        d="M43.8853 21.2608C45.509 21.2608 46.8253 19.9446 46.8253 18.3209C46.8253 16.6971 45.509 15.3809 43.8853 15.3809C42.2616 15.3809 40.9453 16.6971 40.9453 18.3209C40.9453 19.9446 42.2616 21.2608 43.8853 21.2608Z"
                                        fill="#FACC15"/>
                                    <path
                                        d="M56.0962 21.2608C57.72 21.2608 59.0362 19.9446 59.0362 18.3209C59.0362 16.6971 57.72 15.3809 56.0962 15.3809C54.4725 15.3809 53.1562 16.6971 53.1562 18.3209C53.1562 19.9446 54.4725 21.2608 56.0962 21.2608Z"
                                        fill="#FACC15"/>
                                    <path
                                        d="M50.0494 15.2208C51.6731 15.2208 52.9894 13.9045 52.9894 12.2808C52.9894 10.6571 51.6731 9.34082 50.0494 9.34082C48.4257 9.34082 47.1094 10.6571 47.1094 12.2808C47.1094 13.9045 48.4257 15.2208 50.0494 15.2208Z"
                                        fill="#FACC15"/>
                                    <path
                                        d="M50.0494 27.4708C51.6731 27.4708 52.9894 26.1546 52.9894 24.5308C52.9894 22.9071 51.6731 21.5908 50.0494 21.5908C48.4257 21.5908 47.1094 22.9071 47.1094 24.5308C47.1094 26.1546 48.4257 27.4708 50.0494 27.4708Z"
                                        fill="#FACC15"/>
                                </svg>
                            </div>
                        </div>
                        <div className="flex justify-center">
                            <Link to="/game-dev/home">
                                <button className="h-14 w-48 rounded-md text-xl text-black bg-yellow-400 shadow-xl
                             transition-all duration-300 group-hover:scale-105
                             group-hover:shadow-yellow-400/50 group-hover:shadow-2xl">
                                    <span className="capitalize">Enter</span>
                                </button>

                            </Link>
                        </div>
                    </div>


                    <div className="group"
                         onMouseEnter={switchToWebVersion} onMouseLeave={switchToMainVersion}>
                        <div className="card-info relative flex pt-8 sm:pt-0 my-12">
                            <div className="card bg-gray-1 text-white p-6" style={{backgroundImage: `url(${noise})`}}>
                                <div className="py-4 text-xl font-medium border-gray-2 border-b-2">
                                    Web dev:
                                </div>
                                <div className="py-4 font-light">
                                    3DotStudio is a team of web dev enthusiasts with passion for 3d applications and web
                                    games.
                                </div>
                            </div>
                            <div className="card-part bg-gray-1 -ml-4" style={{backgroundImage: `url(${noise})`}}/>
                            <div
                                className="absolute left-32 bottom-52 sm:bottom-48 p-2 flex items-center justify-center bg-gray-1 h-20 w-20 rounded-full border-2 border-amber-400">
                                <svg width="46" height="46" viewBox="0 0 59 58" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 49.5269V56.3709H9.25637" stroke="#FACC15" strokeWidth="3"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M57 49.5269V56.3709H49.7436" stroke="#FACC15" strokeWidth="3"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                    <path
                                        d="M23.9379 33.9528C24.6554 33.5386 24.9012 32.6212 24.487 31.9038C24.0727 31.1864 23.1554 30.9406 22.4379 31.3548L23.9379 33.9528ZM6.53125 42.2706L7.28125 43.5696L23.9379 33.9528L23.1879 32.6538L22.4379 31.3548L5.78125 40.9715L6.53125 42.2706Z"
                                        fill="#FACC15"/>
                                    <path
                                        d="M35.0621 33.9528C34.3446 33.5386 34.0988 32.6212 34.513 31.9038C34.9273 31.1864 35.8446 30.9406 36.5621 31.3548L35.0621 33.9528ZM52.4688 42.2706L51.7187 43.5696L35.0621 33.9528L35.8121 32.6538L36.5621 31.3548L53.2188 40.9715L52.4688 42.2706Z"
                                        fill="#FACC15"/>
                                    <path d="M2 8.84375V1.99967H9.25637" stroke="#FACC15" strokeWidth="3"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M57 8.84375V1.99967H49.7436" stroke="#FACC15" strokeWidth="3"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M29.295 56.3711V28.9123L5.54688 15.9663V42.6601L29.295 56.3711Z"
                                          stroke="#FACC15" strokeWidth="3" strokeLinejoin="round"/>
                                    <path d="M29.5409 56.3711V28.9123L53.2891 15.9663V42.6601L29.5409 56.3711Z"
                                          stroke="#FACC15" strokeWidth="3" strokeLinejoin="round"/>
                                    <path d="M53.2905 15.9659L29.1307 2.05176L5.54688 15.9659" stroke="#FACC15"
                                          strokeWidth="3" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <div className="flex justify-center">
                            <Link to="/web">
                                <button className="h-14 w-48 rounded-md text-xl text-black bg-yellow-400 shadow-xl
                             transition-all duration-300 group-hover:scale-105
                             group-hover:shadow-yellow-400/50 group-hover:shadow-2xl">
                                    <span className="capitalize">Enter</span>
                                </button>


                            </Link>
                        </div>
                    </div>

                    <div className="radiant-white hidden 2xl:flex">
                        <img src={gradientW} alt=''/>
                    </div>

                    <div className="radiant-yellow hidden 2xl:flex">
                        <img src={gradientY} alt=''/>
                    </div>
                </div>

            </div>
            <Footer isVisibleMenu={false}/>


        </div>
    );
}